import React from "react";
import styles from "./FooterSection.module.css";

export const FooterSection = ({children}) => {

    return <h1 className={styles.footer}>{children}</h1>

}

export const FooterSectionLink = ({children, href, onClick}) => {

    return <div className={styles.footerSection}><a className={styles.footerSectionLink} href={href} onClick={onClick}>
        {children}
    </a></div>

}
